import { RefObject, useCallback, useEffect } from "react";

export default function useOutsideClick(
    elements: RefObject<HTMLElement> | RefObject<HTMLElement>[],
    callback: (...args: any[]) => void,
    eventType: "mousedown" | "click" = "click"
) {
    const eventListenerCallback = useCallback(
        (event: MouseEvent) => {
            const target = event.target;
            if (!(target instanceof HTMLElement)) return;

            const refs = Array.isArray(elements) ? elements : [elements];

            const isClickInside = refs.some((ref) => {
                return ref.current && ref.current?.contains(target);
            });

            if (!isClickInside) {
                callback();
            }
        },
        [callback, elements]
    );

    useEffect(() => {
        document.addEventListener(eventType, eventListenerCallback);

        return () => {
            document.removeEventListener(eventType, eventListenerCallback);
        };
    }, [eventListenerCallback, eventType]);
}
